var map = {
	"./el-button.js": "./src/components/render/slots/el-button.js",
	"./el-checkbox-group.js": "./src/components/render/slots/el-checkbox-group.js",
	"./el-input.js": "./src/components/render/slots/el-input.js",
	"./el-radio-group.js": "./src/components/render/slots/el-radio-group.js",
	"./el-select.js": "./src/components/render/slots/el-select.js",
	"./el-upload.js": "./src/components/render/slots/el-upload.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/render/slots sync \\.js$";